export default {
  executor_changing: "can_change_executor",
};
